import { useTranslations } from '@vocab/react';

import { ColumnCard } from 'src/components/Card/ColumnCard';
import { LoadingItem } from 'src/components/LoadingBlock/LoadingBlock';
import { PROFILE_VISIBILITY_V2 } from 'src/components/Router';
import { useMode } from 'src/components/Router/useMode';
import { useNavigateRoute } from 'src/components/Router/useNavigateRoute';
import { EDIT } from 'src/consts';
import { analyticsClient } from 'src/modules/analytics';

import { EditProfileVisibility } from '../EditProfileVisibility/EditProfileVisibilityContainer';

import translations from './.vocab';
import { ProfileVisibilityStatus } from './ReadProfileVisibilityStatus';

interface Props {
  loading?: boolean;
}

export const ReadProfileVisibility = ({ loading }: Props) => {
  const { t } = useTranslations(translations);

  const navigate = useNavigateRoute();
  const mode = useMode(PROFILE_VISIBILITY_V2);
  const isDrawerOpen = mode === EDIT;

  const handleProfileVisibilityEditClicked = () => {
    analyticsClient.cardOpened({
      currentPageSection: 'visibility settings',
      currentPageSectionState: 'edit',
    });
    navigate({
      card: PROFILE_VISIBILITY_V2,
      mode: EDIT,
    });
  };

  const cardButtonProps = {
    onClick: handleProfileVisibilityEditClicked,
    label: t('Edit visibility'),
  };

  return (
    <>
      <ColumnCard
        name={PROFILE_VISIBILITY_V2}
        title={t('Profile visibility')}
        loader={<LoadingItem type="text" size="standard" width="large" />}
        loading={loading}
        buttonProps={cardButtonProps}
      >
        <ProfileVisibilityStatus loading={loading} />
      </ColumnCard>
      <EditProfileVisibility isOpen={isDrawerOpen} />
    </>
  );
};
